import { ErrorPage, InfoCardInner, LoadingPage, Modal, TInfoCardSectionColumnProps } from '@chocolate-soup-inc/cs-frontend-components';
import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { EmployeeModal } from './EmployeeModal';

import { toast } from 'react-toastify';
import { TDependantType, useQueryAllEmployeeDependants } from '../../entities/dependants/queries';
import { useQueryOneEmployee } from '../../entities/employees/queries';
import { TDependantType as TDependantTypes } from '../../generated/graphql';

export const EmployeeDependants = () => {
  const navigate = useNavigate();
  const { employeeId = '0' } = useParams();

  const {
    data: employee,
    error,
    loading
  } = useQueryOneEmployee({
    id: employeeId
  });

  const {
    data: dependants,
    error: dependantsError,
    loading: dependantsLoading
  } = useQueryAllEmployeeDependants({
    employeeId,
    companyId: employee.companyId
  });

  const title = useMemo(() => {
    const fullName = employee?.fullName;
    if (fullName) return `${fullName} Dependants`;
    else return 'Employee Dependants';
  }, [employee]);

  const dependantColumns = useCallback((dependant: TDependantType) => {
    const cols: TInfoCardSectionColumnProps<TDependantType>[] = [
      {
        label: 'Relationship',
        accessor: 'type',
        render: (data) => {
          if (data?.type === 'significantOther') return 'Significant Other';
          else return _.capitalize(data?.type);
        }
      },
      {
        label: 'Date of Birth',
        accessor: 'birthDate'
      },
      {
        label: 'First Name',
        accessor: 'firstName'
      }
    ];

    if (dependant.type === TDependantTypes.Pet)
      cols.push({
        label: 'Pet Type',
        accessor: 'petType'
      });
    else
      cols.push({
        label: 'Last Name',
        accessor: 'lastName'
      });

    if (dependant.type === TDependantTypes.SignificantOther)
      cols.push({
        label: 'Donate Birthday Gift',
        render: (data) => {
          if (data?.donateBirthdayGift) return 'yes';
          else return 'no';
        }
      });

    return cols;
  }, []);

  if (loading || dependantsLoading)
    return (
      <Modal closeModal={() => navigate(generatePath('../../'))} headline={title}>
        <LoadingPage />
      </Modal>
    );

  if (error || dependantsError) {
    console.error('query Apollo ERROR:', error);
    console.error('query Apollo ERROR:', dependantsError);
    toast.error('An error has ocurred, check the console for details. (query Apollo ERROR)');
    //if (error.message) toast.error(error.message);
    //if (dependantsError.message) toast.error(dependantsError.message);
    if (!dependants)
      return (
        <Modal closeModal={() => navigate(generatePath('../../'))} headline={title}>
          <ErrorPage error={error || dependantsError} />
        </Modal>
      );
  }

  return (
    <EmployeeModal employee={employee} headline={title}>
      <div>
        {dependants.length === 0 && <p>No dependants registered for this employee.</p>}
        {dependants.map((dependant, index) => (
          <InfoCardInner<TDependantType>
            key={dependant.id}
            sections={[
              {
                title: `Dependant #${index + 1}`,
                columns: dependantColumns(dependant)
              },
              {
                columns: [
                  {
                    label: 'Allergies & Dietary Restrictions',
                    accessor: 'foodPreferences'
                  }
                ]
              }
            ]}
            data={dependant}
          />
        ))}
      </div>
    </EmployeeModal>
  );
};
